var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"danceSchedule",style:(_vm.width)},[_c('v-app',{staticStyle:{"background-color":"transparent !important"}},[_c('AppBar'),_c('v-main',[_c('div',{staticClass:"Schedule"},[_c('AppWindow')],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }